import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {PelunasanStatus} from "../config";
import {fetchDataAsync} from "../../../../../Services/Utils";
import {HttpStatus} from "../../../../common/Constants";

class Filter extends Component {
    statusOptions = [
        {
            label: PelunasanStatus.BELUM_DIBAYAR.replace(/_/g, " "),
            value: PelunasanStatus.BELUM_DIBAYAR,
        },
        {
            label: PelunasanStatus.INCOMPLETE,
            value: PelunasanStatus.INCOMPLETE,
        },
        {
            label: PelunasanStatus.LUNAS,
            value: PelunasanStatus.LUNAS,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            leasingNameOptions: [],
            colorNameOptions: [],
            typeOptions: [],
            loading: false,
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const responses = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
                menuName: "Penagihan Leasing",
                args: {},
                setError: this.props.setError,
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarna,
                menuName: "Penagihan Leasing",
                args: null,
                setError: this.props.setError,
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllType,
                menuName: "Penagihan Leasing",
                args: null,
                setError: this.props.setError,
            }),
        ]);

        responses.forEach((response, idx) => {
            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                if (idx === 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        leasingNameOptions: [
                            {label: "ALL", value: "ALL"},
                            ...response.data.data.map((d) =>
                                mapToObjectDDL(d.leasingName, d.leasingName)
                            ),
                        ]
                    }));
                } else if (idx === 1) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        colorNameOptions: [
                            {label: "ALL", value: "ALL"},
                            ...response.data.data.map((d) =>
                                mapToObjectDDL(d.namaWarnaKomersil, d.namaWarnaKomersil)
                            ),
                        ]
                    }));
                } else if (idx === 2) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        typeOptions: [
                            {label: "ALL", value: "ALL"},
                            ...response.data.data.map((d) =>
                                mapToObjectDDL(d.typeName, d.id),
                            ),
                        ]
                    }));
                }
            }
        });
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    render() {
        return (
            <>
                <SimpleModal
                    title="Filter Search"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <SimpleInput
                                id="input_text_no_faktur_jual"
                                name="nomorFakturJual"
                                label="Nomor Faktur Jual"
                                value={this.props.state.filterData?.nomorFakturJual}
                                onChange={({target}) => this.props.onFilterChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_no_po"
                                name="nomorPO"
                                label="Nomor PO"
                                value={this.props.state.filterData?.nomorPO}
                                onChange={({target}) => this.props.onFilterChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_no_buku"
                                name="nomorBuku"
                                label="Nomor Buku"
                                value={this.props.state.filterData?.nomorBuku}
                                onChange={({target}) => this.props.onFilterChange(target.name, target.value)}
                            />
                            <SimpleDDL
                                id="select_options_nama_leasing"
                                box="multiselect"
                                name="listNamaLeasing"
                                label="Nama Leasing"
                                isClearable
                                options={this.state.leasingNameOptions}
                                value={this.props.state.filterData?.listNamaLeasing || []}
                                onChange={(value, {name}) => this.props.onFilterChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_nama_tipe"
                                box="multiselect"
                                name="listNamaType"
                                label="Nama Tipe"
                                isClearable
                                options={this.state.typeOptions}
                                value={this.props.state.filterData?.listNamaType || []}
                                onChange={(value, {name}) => this.props.onFilterChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_nama_warna"
                                box="multiselect"
                                name="listNamaWarna"
                                label="Nama Warna"
                                isClearable
                                options={this.state.colorNameOptions}
                                value={this.props.state.filterData?.listNamaWarna || []}
                                onChange={(value, {name}) => this.props.onFilterChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_nama_stnk"
                                name="namaSTNK"
                                label="Nama STNK"
                                value={this.props.state.filterData?.namaSTNK}
                                onChange={({target}) => this.props.onFilterChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_nama_pembeli"
                                name="namaPembeli"
                                label="Nama Pembeli"
                                value={this.props.state.filterData?.namaPembeli}
                                onChange={({target}) => this.props.onFilterChange(target.name, target.value)}
                            />
                            {this.props.showStatus && (
                                <SimpleDDL
                                    id="select_options_status"
                                    box="multiselect"
                                    isClearable
                                    name="listStatusPelunasan"
                                    label="Status"
                                    options={this.statusOptions}
                                    value={this.props.state.filterData?.listStatusPelunasan}
                                    onChange={(value, {name}) => this.props.onFilterChange(name, value)}
                                />
                            )}
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <SimpleButton secondary onClick={this.props.onClearFilter}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton
                                    onClick={async () => {
                                        await this.props.onSubmitFilter();
                                        this.props.onClickClose();
                                    }}
                                >
                                    Terapkan
                                </SimpleButton>
                            </div>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default Filter;
